export function getProperLinkStyles(data, styleState) {
    const isUnderline = !!data.underline;
    const isTextDecoration = !!data.textDecoration;

    if (isUnderline) {
        return {
            borderBottomWidth: data.underline[styleState].width,
            borderBottomStyle: data.underline[styleState].style,
            borderBottomColor: data.underline[styleState].color
        };
    }

    if (isTextDecoration) {
        return {
            textDecoration: data.textDecoration[styleState]
        };
    }

    return {};
}



// WEBPACK FOOTER //
// ./src/utils/links.js